import { j as e } from "../../../node_modules/react/jsx-runtime.js";
import t from "../../atoms/Tag/Tag.js";
import { useState as v, useMemo as c } from "react";
import x from "./TagGroup.module.scss.js";
import { i18n as N } from "../../../utils/locale/locale.js";
import b from "../../atoms/Tooltip/Tooltip.js";
import g from "../../atoms/ScrollbarContainer/ScrollBarContainer.js";
const B = ({
  testId: f,
  tags: r,
  maxTagWidth: i,
  maxTags: s = 3,
  width: a = "100%",
  overflowType: p = "default",
  tooltipPlacement: h = "bottom"
}) => {
  const [o, j] = v(!1), d = c(() => r.length > Number(s) && !o ? r.slice(0, s) : r, [r, s, o]), l = c(
    () => r.length > Number(s) ? r.slice(s) : [],
    [r, s]
  ), u = c(() => /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "flex flex-wrap gap-050",
      style: { width: a },
      children: [
        d.map((n, m) => /* @__PURE__ */ e.jsx(
          t,
          {
            ...n,
            maxWidth: i
          },
          m
        )),
        l.length > 0 && /* @__PURE__ */ e.jsx(e.Fragment, { children: p === "popover" ? /* @__PURE__ */ e.jsx(
          b,
          {
            placement: h,
            behavior: "popover",
            trigger: /* @__PURE__ */ e.jsx("div", { className: x.moreTags, children: /* @__PURE__ */ e.jsx(
              t,
              {
                label: `+${l.length}`,
                onClick: void 0
              }
            ) }),
            children: /* @__PURE__ */ e.jsx(g, { className: "flex h-fit max-h-[200px]", children: /* @__PURE__ */ e.jsx("div", { className: "flex flex-wrap h-fit gap-200", children: l.map((n, m) => /* @__PURE__ */ e.jsx(
              t,
              {
                maxWidth: i,
                ...n
              },
              m
            )) }) })
          }
        ) : /* @__PURE__ */ e.jsx("div", { className: x.moreTags, children: /* @__PURE__ */ e.jsx(
          t,
          {
            label: o ? N("less") : `+${l.length}`,
            onClick: () => j(!o)
          }
        ) }) })
      ]
    }
  ), [d, l, o, a, p, h, i]);
  return /* @__PURE__ */ e.jsx("div", { "data-testid": f, children: u });
};
export {
  B as default
};
//# sourceMappingURL=TagGroup.js.map
